import { ReactNode, createContext, useEffect, useState } from "react";
import { getWorkOrderById } from "../../../../../common/services/workOrder.api";
import { emptyWorkOrder, IWorkOrder } from "../../../../../types/workorder.types";

type InitialStateType = {
  workOrder: IWorkOrder
}

const initialState: InitialStateType = {
  workOrder: emptyWorkOrder(),
}
// eslint-disable-next-line react-refresh/only-export-components
export const PreparationReportsDashboardContext = createContext(initialState)

type Props = {
  children: ReactNode,
  workOrderId: string
}

export function PreparationReportsDashboardProvider(props: Props) {

  const [workOrder, setWorkOrder] = useState<IWorkOrder>(initialState.workOrder)

  useEffect(() => {
    async function loadPreparation(workOrderId: string) {
      const result = await getWorkOrderById(workOrderId)

      if (result.ok) {
        setWorkOrder(result.data as IWorkOrder)
      }
    }

    loadPreparation(props.workOrderId)
  }, [props.workOrderId])

  const theState = { workOrder }

  return (
    <PreparationReportsDashboardContext.Provider value={theState as InitialStateType}>
      {props.children}
    </PreparationReportsDashboardContext.Provider>
  )
}